import { render, staticRenderFns } from "./SectionStory.vue?vue&type=template&id=7b23377e&scoped=true"
import script from "./SectionStory.vue?vue&type=script&lang=js"
export * from "./SectionStory.vue?vue&type=script&lang=js"
import style0 from "./SectionStory.vue?vue&type=style&index=0&id=7b23377e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23377e",
  null
  
)

export default component.exports